import { QueovalBase } from '../global/class.global';
import { Select } from '../utilities';
export class ImportSilaeModel extends QueovalBase {

  public config: ConfigSilae;
  public clientInfoSilae: Array<ClientInfoSilae>;


  public typeMissionList: Array<Select>;
  public relMissionList: Array<Select>;
  public articleList: Array<Select>;
  public fileList: Array<Select>;
  public uniteList: Array<Select>;


  public annee: Array<Select>;
  public mois: Array<Select>;

  public historique: HistoSilae;
  public csvReport: string;
  public path: string;

  public listIdToDelete: Array<String>;

  constructor() {
    super();
    this.config = new ConfigSilae();
    this.clientInfoSilae = new Array<ClientInfoSilae>();
    this.historique = new HistoSilae();

    this.typeMissionList = new Array<Select>();
    this.relMissionList = new Array<Select>();
    this.articleList = new Array<Select>();
    this.fileList = new Array<Select>();
    this.uniteList = new Array<Select>();

    this.listIdToDelete = new Array<String>();
  }
}


export class ConfigSilae {
  public configGeneral: ConfigSilaeGeneral;
  public configMission: Array<ConfigSilaeMission>;
  constructor() {
    this.configGeneral = new ConfigSilaeGeneral();
    this.configMission = new Array<ConfigSilaeMission>();
  }
}

export class ConfigSilaeGeneral {
  public client: Select;

  public mois: string;
  public annee: string;

  public colClient: number;
  public colRaiso: number;
  public colAgence: number;

  public moisMoins1: boolean;

  public fileName: string;
  public csvName: string;
  public startProcessingLine: number;
  constructor() {
    this.client = new Select();
    this.startProcessingLine = 1;
    this.moisMoins1 = false;
  }
}

export class ConfigSilaeMission {

  public article: SelectSilae;
  public mission: SelectSilae;
  public typeMission: SelectSilae;
  public unite: SelectSilae;

  public colMontant: number;
  public colQuantite: number;
  public colInfo: number;

  public ident: number;
  public editable: boolean;
  public designation: boolean;

  constructor() {
    this.article = new SelectSilae();
    this.mission = new SelectSilae();
    this.typeMission = new SelectSilae();
    this.unite = new SelectSilae();

    this.designation = false;
    this.editable = false;
  }
}

export class HistoSilae {
  public clientInfoSilae: Array<ClientInfoSilae>;
  public histoList: Array<SilaeHistoSelect>;
  public fileName: string;
  constructor() {
    this.histoList = new Array<SilaeHistoSelect>();
    this.clientInfoSilae = new Array<ClientInfoSilae>();
  }

}


export class SilaeHistoSelect extends Select{
  public nbCreated: number;
  public nbAttached: number;
  public nbDeleted: number;
  public nbNotCreated: number;
  public dtCreateFile: string;
  public canDelete: boolean;
  public baseName: string;
}


export class ClientInfoSilae {
  public ident: string;
  public siret: string;
  public raisoCli: string;
  public hasError: boolean;
  public hasErrorClot: boolean;

  public mission: Array<SilaeMission>;

  constructor() {
    this.mission = new Array<SilaeMission>();
  }
}
export class SilaeMission {
  public article: Select;
  public mission: Select;
  public montant: number;
  public quantite: number;
  public info: string;

  public idLigne: string;
  public state: SilaeLigneState;
  public isConvention: boolean;
  public HasError: boolean;
  public silaeError: Array<SilaeError>;
  constructor() {
    this.silaeError = new Array<SilaeError>();
  }



}

export enum SilaeError {
  Mission = 1,
  ModeFacturation = 2,
  Montant = 3,
  Forfait = 4,
  Quantite = 5,
  Convention = 6
}

export enum SilaeLigneState {
  NotCreated = 0,
  Created = 1,
  Attached = 2,
  Deleted = 3,
}

export class SelectSilae {
  public id: string;
  public value: string;

  constructor() {
    this.id = '';
    this.value = '-------';
  }
}
